import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

const Store = new Vuex.Store({
    state: {
        favorites: [],
        educationFilters: {},
        queryFilters: [],
        educations: [],
        showFilters: false,
        showHiddenFilters: false,
        currentOpenFilter: 0
    },
    getters: {
        getAllFavorites: state => {
            return state.favorites;
        },
        getFavoriteById: state => id => {
            let favorites = [];
            favorites = favorites.concat(state.favorites);
            const index = favorites.indexOf(id);
            return index > -1;
        },
        getEducationFilters: state => {
            return state.educationFilters;
        },
        getEducationActiveFilters: state => {
            const result = [];
            for (const prop in state.educationFilters) {
                state.educationFilters[prop].filters.forEach(filter => {
                    if (filter.filter in state.queryFilters) {
                        result.push(filter);
                    }
                });
            }
            return result;
        },
        getEducations: state => {
            return state.educations;
        },
        getShowFilters: state => {
            return state.showFilters;
        },
        getEducationQueryString: state => {
            if (state.queryFilters.length === 0) {
                return '';
            } else if (state.queryFilters.length === 1) {
                return '?filter=' + state.queryFilters[0];
            } else {
                return '?filter=' + state.queryFilters.join('&filter=');
            }
        },
        getEducationCount: state => {
            if (state.educations) {
                return state.educations.length;
            }
            return 0;
        },
        getSelectedFilters: state => {
            const result = [];
            for (const prop in state.educationFilters) {
                state.educationFilters[prop].filters.forEach(filter => {
                    if (state.queryFilters.indexOf(filter.filter) > -1) {
                        result.push(filter);
                    }
                });
            }
            return result;
        },
        getSelectedFilter: state => {
            const result = {};
            for (const prop in state.educationFilters) {
                state.educationFilters[prop].filters.forEach(filter => {
                    result[filter.filter] =
                        state.queryFilters.indexOf(filter.filter) > -1;
                });
            }
            return result;
        },
        getQueryFilters: state => {
            return state.queryFilters;
        },
        showHiddenFilters: state => {
            return state.queryFilters.length > 4 && state.showHiddenFilters;
        },
        getCurrentOpenFilter: state => {
            return state.currentOpenFilter;
        }
    },
    mutations: {
        initialiseStore(state) {
            if (localStorage.getItem('Store')) {
                const favs = localStorage.getItem('Store');
                if (favs) {
                    state.favorites = JSON.parse(localStorage.getItem('Store'));
                }
            }
        },
        addFavorite(state, id) {
            const index = state.favorites.indexOf(id);

            if (index < 0) {
                this.state.favorites.push(id);
            }
        },
        removeFavorite(state, id) {
            const index = state.favorites.indexOf(id);

            if (index > -1) {
                state.favorites.splice(index, 1);
            }
        },
        initFilters(state) {
            state.queryFilters = [];
            let query = window.location.href;
            const filters = [];
            if (query.indexOf('?') > -1) {
                const queryParts = query.split('?')[1].split('&');
                queryParts.forEach(data => {
                    const filter = data.split('=');
                    if (filter[0] === 'filter') {
                        filters.push(filter[1]);
                    }
                });
            } else {
                query = '';
            }
            state.queryFilters = filters;
            this.dispatch('doStuff');
        },
        setEducations(state, data) {
            state.educationFilters = data.filters;
            state.educations = data.results;
            state.showFilters = true;
        },
        addFilter(state, filter) {
            const index = state.queryFilters.indexOf(filter.filter);
            if (index > -1) {
                state.queryFilters.splice(index, 1);
                if (state.queryFilters.length < 5) {
                    state.showHiddenFilters = false;
                }
            } else {
                state.queryFilters.push(filter.filter);
            }
            this.dispatch('doStuff');
        },
        clearFilter(state) {
            state.queryFilters = [];
        },
        setShowFilters(state) {
            state.showHiddenFilters = true;
        },
        setCurrentOpenFilter(state, current) {
            state.currentOpenFilter = current;
        }
    },
    actions: {
        doStuff() {
            const url = '/api/EducationApi/GetFiltersEducations';
            axios({
                method: 'get',
                url: url + this.getters.getEducationQueryString
            })
                .then(response => {
                    if (!response.data === null) {
                        return false;
                    }
                    this.commit('setEducations', response.data);
                    return true;
                })
                .catch(() => false);
        }
    }
});

Store.subscribe((mutation, state) => {
    localStorage.setItem('Store', JSON.stringify(state.favorites));
});

export default Store;
